import { removeSelectedCartLines } from "@aihCustomBlueprint/Services/AlaskaCartService";
import { AIHActions } from "@aihCustomBlueprint/Store/CustomApplicationState";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    makeHandlerChainAwaitable,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { CartModel } from "@insite/client-framework/Types/ApiModels";
import { DispatchProp } from "react-redux";

type HandlerType = ApiHandler<
    CartModel & HasOnSuccess<string> & HasOnError<string>,
    ServiceResult<string>,
    DispatchProp<AIHActions>
>;

export const DispatchBeginRemoveCartLine: HandlerType = props => {
    props.dispatch({
        type: "Context/BeginUpdatingCart",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const RemoveCartLinesFromCart: HandlerType = async props => {
    const result = await removeSelectedCartLines(props.apiParameter);
    if (result.successful) {
        props.apiResult = result;
    } else {
        props.dispatch({
            type: "Pages/Cart/CompleteSavingOrder",
        });
        props.dispatch({
            type: "Context/CompleteUpdatingCart",
        });
        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const DispatchCompleteSavingOrder: HandlerType = props => {
    props.dispatch({
        type: "Pages/Cart/CompleteSavingOrder",
    });
    props.dispatch({
        type: "Context/CompleteUpdatingCart",
    });
};

export const DispatchCompleteRemoveCartLine: HandlerType = props => {
    props.dispatch({
        type: "Context/CompleteUpdatingCart",
    });
    props.dispatch({
        type: "Data/OrderApprovals/Reset",
    });
};

export const LoadCart: HandlerType = async props => {
    const awaitableLoadCurrentCart = makeHandlerChainAwaitable(loadCurrentCart);
    await awaitableLoadCurrentCart({ getPromotions: true })(props.dispatch, props.getState);
};

export const chain = [
    DispatchBeginRemoveCartLine,
    PopulateApiParameter,
    RemoveCartLinesFromCart,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
    DispatchCompleteSavingOrder,
    DispatchCompleteRemoveCartLine,
    LoadCart,
];

const removeCartLinesFromCart = createHandlerChainRunner(chain, "RemoveCartLinesFromCart");
export default removeCartLinesFromCart;
